/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_ItalicInputs */

const en_tables_custom_properties_italic = /** @type {(inputs: Tables_Custom_Properties_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Italic`)
};

const de_tables_custom_properties_italic = /** @type {(inputs: Tables_Custom_Properties_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursiv`)
};

/**
* | output |
* | --- |
* | "Properties Italic" |
*
* @param {Tables_Custom_Properties_ItalicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_italic = /** @type {((inputs?: Tables_Custom_Properties_ItalicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_ItalicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_italic(inputs)
	return de_tables_custom_properties_italic(inputs)
});